import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';

@Component({
    selector: 'fi-checklist2-list-changed-on',
    templateUrl: './fi-checklist2-list-changed-on.component.html',
    styleUrls: ['./fi-checklist2-list-changed-on.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-changed-on' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListChangedOnComponent }],
    standalone: false,
})
export class FiChecklist2ListChangedOnComponent extends FiWrapperTableAdditionalColumns {}
